import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../theme';

const { colors, spacing, breakpoints } = redesignTheme;

export const positionedWrapperStyle = {
  position: 'relative',
} as const;

export const pageHeaderIntroStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.xs,
} as const;

export const useSharedStyles = makeStyles(() => ({
  loadingCenter: {
    minHeight: '60vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  pageShell: {
    width: '100%',
    minHeight: '100%',
    backgroundColor: colors.background,
    boxSizing: 'border-box',
    padding: `${spacing.md}px ${spacing.sm}px ${spacing.xl}px`,
    [`@media (min-width: ${breakpoints.desktop}px)`]: {
      padding: `${spacing.md}px 40px ${spacing.xl}px`,
    },
  },
  pageHeaderIntro: {
    ...pageHeaderIntroStyle,
  },
}));
